<div class="cm-node-flex-container">
    @if ($amountGroupNode()?.parameters; as parameters) {
        <div class="node-icon" matTooltip="Amount Group" matTooltipPosition="above">
            <i class="fa-solid fa-hashtag"></i>
            <i class="fa-solid fa-hashtag"></i>
        </div>
        <span class="cm-node-text">{{ $description() }}</span>
        <div class="cm-tools-right">
            <input name="defaultAmount" class="cm-input-width-limit" type="number" min="0" [(ngModel)]="parameters.defaultAmount" />
        </div>
    }
</div>
